export enum EnumTipoTrade {
  "Intercambio" = 1,
  "Compra",
  "Venta",
  "Swaps",
  "Compra/Venta"
}